var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container d-flex justify-content-center"},[(_vm.opacity > 0)?_c('b-spinner',{staticStyle:{"padding-top":"3rem","width":"5rem","height":"5rem"},attrs:{"id":"PageLoadingIndicator","label":_vm.$t('loadingIndicatorLabel'),"variant":"primary"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }